<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32" fill="none">
    <path
      d="M16 6C14.0222 6 12.0888 6.58649 10.4443 7.6853C8.79981 8.78412 7.51809 10.3459 6.76121 12.1732C6.00433 14.0004 5.8063 16.0111 6.19215 17.9509C6.578 19.8907 7.53041 21.6725 8.92894 23.0711C10.3275 24.4696 12.1093 25.422 14.0491 25.8078C15.9889 26.1937 17.9996 25.9957 19.8268 25.2388C21.6541 24.4819 23.2159 23.2002 24.3147 21.5557C25.4135 19.9112 26 17.9778 26 16C26 13.3478 24.9464 10.8043 23.0711 8.92893C21.1957 7.05357 18.6522 6 16 6ZM16 24.3333C14.3518 24.3333 12.7407 23.8446 11.3703 22.9289C9.99984 22.0132 8.93174 20.7117 8.30101 19.189C7.67028 17.6663 7.50525 15.9908 7.82679 14.3742C8.14834 12.7577 8.94201 11.2729 10.1074 10.1074C11.2729 8.94201 12.7577 8.14833 14.3742 7.82679C15.9908 7.50525 17.6663 7.67027 19.189 8.301C20.7117 8.93173 22.0132 9.99984 22.9289 11.3702C23.8446 12.7407 24.3333 14.3518 24.3333 16C24.3333 18.2101 23.4554 20.3297 21.8926 21.8926C20.3298 23.4554 18.2101 24.3333 16 24.3333Z"
      :class="[props.state]"/>
    <path
      d="M20.275 19.175L16.4167 15.6333V11.4167C16.4167 11.1957 16.3289 10.9837 16.1726 10.8274C16.0163 10.6711 15.8043 10.5833 15.5833 10.5833C15.3623 10.5833 15.1504 10.6711 14.9941 10.8274C14.8378 10.9837 14.75 11.1957 14.75 11.4167V16C14.7492 16.1157 14.7725 16.2302 14.8184 16.3364C14.8643 16.4426 14.9319 16.538 15.0167 16.6167L19.1833 20.4C19.2641 20.4749 19.3588 20.5331 19.4622 20.5712C19.5655 20.6092 19.6754 20.6265 19.7854 20.6218C19.8955 20.6172 20.0035 20.5907 20.1033 20.5441C20.203 20.4974 20.2925 20.4315 20.3667 20.35C20.4378 20.2668 20.4919 20.1705 20.5258 20.0664C20.5596 19.9623 20.5727 19.8526 20.5642 19.7435C20.5557 19.6344 20.5258 19.528 20.4761 19.4305C20.4265 19.3329 20.3582 19.2461 20.275 19.175Z"
      :class="[props.state]"
      />
  </svg>
</template>

<script setup lang="ts">
export type State = 'active' | 'inactive';

const props = withDefaults(defineProps<{
  state?: State;
}>(), {
  state: 'active'
});


</script>

<style lang="scss" scoped>
.active {
  fill: white;
}

.inactive {
  fill: var(--Primary-160);
}
</style>
